let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g1oCq")).then(() => parcelRequire('lvWgo'));